import React from 'react';
import { Tab, Grid, Header, Icon, Ref, Divider } from 'semantic-ui-react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import _ from 'lodash';
import classNames from 'classnames';

import {
  REPORT_WRITER_TABS,
  DroppableAreaEnum,
  SelectedReportOptionsMaxColumnsPerRow,
} from 'Pages/productionreportsetup/helpers/Constants';

function SelectedReportOptions({
  reportColumns,
  setReportColumns,
  selectedColumn,
  onDeleteColumn,
}) {
  const columns = reportColumns[selectedColumn];
  const columnChunks = _.chunk(columns, SelectedReportOptionsMaxColumnsPerRow);
  const colNumbers = _.chunk(
    _.range(columns.length),
    SelectedReportOptionsMaxColumnsPerRow
  );

  const onAddColumn = () => {
    setReportColumns({ ...reportColumns, [selectedColumn]: [...columns, []] });
  };

  const isAddVisible = () => {
    return selectedColumn === REPORT_WRITER_TABS.ReportHeader &&
      columns.length >= 5
      ? 'hidden'
      : '';
  };

  return (
    <Tab.Pane>
      <Grid className="cprt-tab-grid">
        <Grid.Row>
          <Grid.Column className="cprt-add-col">
            <div
              className={`cptr-add-col-container ${isAddVisible()}`}
              onClick={(e, d) => onAddColumn(e, columns)}
            >
              <Icon circular={true} size="small" name="plus" />
              <span className="cprt-add-col-text">Add Column</span>
            </div>
          </Grid.Column>
        </Grid.Row>
        {colNumbers.map((numbers, i) => (
          <React.Fragment key={i}>
            <Grid.Row columns={SelectedReportOptionsMaxColumnsPerRow}>
              {numbers.map((n) => (
                <Grid.Column key={n}>
                  <Header as="h5">
                    <span className="crpt-col-text">
                      Column {n + 1}
                      <Icon
                        link={true}
                        circular={true}
                        size="small"
                        name="close"
                        onClick={() => onDeleteColumn(n)}
                      />
                    </span>
                  </Header>
                </Grid.Column>
              ))}
            </Grid.Row>
            <Grid.Row columns={SelectedReportOptionsMaxColumnsPerRow} key={i}>
              {columnChunks[i].map((columnItems, j) => (
                <Droppable
                  droppableId={`${DroppableAreaEnum.ReportSection}-${
                    SelectedReportOptionsMaxColumnsPerRow * i + j
                  }`}
                  key={`${DroppableAreaEnum.ReportSection}-${
                    SelectedReportOptionsMaxColumnsPerRow * i + j
                  }`}
                >
                  {(provided, snapshot) => (
                    <Ref innerRef={provided.innerRef}>
                      <Grid.Column
                        className="cprt-grid-column"
                        {...provided.droppableProps}
                      >
                        {columnItems.map((item, columnItemIndex) => (
                          <Draggable
                            index={columnItemIndex}
                            key={item.Id}
                            draggableId={item.Id}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={classNames(
                                  'cprt-grid-cell',
                                  snapshot.isDragging &&
                                    'cprt-grid-cell-dragging',
                                  item.Required && 'required'
                                )}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div className="grip" />
                                <span>{item.Description}</span>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </Grid.Column>
                    </Ref>
                  )}
                </Droppable>
              ))}
            </Grid.Row>
            {columns.length > 4 && (
              <Grid.Row columns={SelectedReportOptionsMaxColumnsPerRow}>
                <Divider
                  style={{
                    width: '100%',
                    marginLeft: '24px',
                    marginRight: '24px',
                  }}
                />
              </Grid.Row>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Tab.Pane>
  );
}

export { SelectedReportOptions };



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/createreporttemplate/components/SelectedReportOptions.js